import { t } from "@lingui/macro";
import {
  type GetClientQuery,
  useGetClientQuery,
} from "@src/__generated__/graphql";
import { useNavigationPages } from "@src/components/widgets/AppSubNav/hooks";
import type { NavigationHook } from "@src/components/widgets/AppSubNav/hooks/types";
import { cannot } from "@src/utils/components/permissions";

export function useClientNavigationPages(
  clientId: string,
): NavigationHook<GetClientQuery["client"]> {
  const { data, loading } = useGetClientQuery({
    variables: { id: clientId },
    skip: !clientId,
    notifyOnNetworkStatusChange: true,
    fetchPolicy: "cache-first",
  });

  const { allPages, activePage, activeSubpage, visiblePages } =
    useNavigationPages([
      {
        href: { pathname: "/clients/detail", query: { id: clientId } },
        title: () => t`Detail`,
        hidden: cannot("client_read"),
      },
      {
        href: { pathname: "/clients/documents", query: { id: clientId } },
        title: () => t`Documents`,
        hidden: cannot("client_read"),
      },
      {
        href: {
          pathname: "/clients/credit-accounts",
          query: { id: clientId },
        },
        title: () => t`Credit accounts`,
        hidden: cannot("client_read"),
      },
      {
        href: { pathname: "/clients/projects", query: { id: clientId } },
        title: () => t`Projects`,
        hidden: cannot("client_read"),
      },
    ]);

  return {
    data: data?.client,
    isLoading: loading,
    visiblePages,
    allPages,
    activePage,
    activeSubpage,
  };
}
